module.exports = __webpack_public_path__ + "static/media/mypage_illust.a258fddb.png";